import React from 'react';
//libraries
import PropTypes from 'prop-types';

//styles
import { StyledStatisticCard } from './style';
import variableStyles from '../../../constants/variables-styles';
import {
  StockOutlined,
  UserAddOutlined,
  UserOutlined,
} from '@ant-design/icons';

function StatisticCard(props) {
  const { type, number, text } = props;

  function renderIcon() {
    switch (type) {
      case 'TOTAL':
        return <StockOutlined />;
      case 'SAMOAN':
        return <UserOutlined />;
      case 'FOREIGNER':
        return <UserAddOutlined />;
      default:
        return <UserOutlined />;
    }
  }

  function renderColor() {
    switch (type) {
      case 'TOTAL':
        return variableStyles.iconActive;
      case 'SAMOAN':
        return variableStyles.iconWarning;
      case 'FOREIGNER':
        return variableStyles.iconSuccess;
      default:
        return variableStyles.iconActive;
    }
  }

  function renderBackgroundColor() {
    switch (type) {
      case 'TOTAL':
        return variableStyles.surfaceSky;
      case 'SAMOAN':
        return variableStyles.surfaceWarning;
      case 'FOREIGNER':
        return variableStyles.surfaceSuccess;
      default:
    }
  }

  return (
    <StyledStatisticCard
      data-color={renderColor()}
      data-background={renderBackgroundColor()}
    >
      <div className="statisticCard-right">
        <h4>
          <span>{number || 0}</span>
        </h4>
        <div className="statisticCard-right__title">
          <span>{text || '--'}</span>
        </div>
      </div>
      <div className="statisticCard-left">
        <i className="flex-center">{renderIcon()}</i>
      </div>
    </StyledStatisticCard>
  );
}

StatisticCard.propTypes = {
  type: PropTypes.string,
  number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  text: PropTypes.string,
};

StatisticCard.defaultProps = {
  type: 'data',
};

export default StatisticCard;
